import { render, staticRenderFns } from "./IncRestaurantLogo.vue?vue&type=template&id=2dcc4421"
import script from "./IncRestaurantLogo.vue?vue&type=script&lang=js"
export * from "./IncRestaurantLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports